<script lang="ts">
    import { getContext, onMount } from "svelte";
    import { _ } from "svelte-i18n";
    import { Writable, get } from "svelte/store";
    import ToolBoxModal from "../controls/toolbox/ToolBoxModal.svelte";
    import { FormGroup, Input } from "sveltestrap";
    import type { CompareToolBoxManager } from "./CompareToolBoxManager";
    import type { ScenarioData } from "../../api/projects/data/scenarios/ScenarioData";

    export let manager: CompareToolBoxManager;
    let openToolBox = manager.getOpenToolBoxStore();
    let branchCommitId = manager.getReferenceBranchIdStore();
    let otherScenarios = manager.getOtherScenariosStore();

    let scenarioId: string;
    let scenarios: {
        scenario: ScenarioData;
        commitId: string;
        isCurrent: boolean;
        isIdentical: boolean;
        value: string;
        label: string;
        title: string;
    }[] = [];
    let isChecked = false;

    $: if (!isChecked) {
        branchCommitId.set(undefined);
    } else {
        const scenario = scenarios.find((x) => x.scenario.id == scenarioId);
        if (typeof scenario == "undefined") {
            branchCommitId.set(undefined);
        } else {
            branchCommitId.set(scenario.scenario.branchId);
        }
    }

    const onOtherScenarioUpdated = () => {
        const os = get(otherScenarios);
        if (typeof os === "undefined") return;

        scenarios = os.map((x) => {
            return {
                commitId: x.commitId,
                isCurrent: x.isCurrent,
                isIdentical: x.isIdentical,
                value: x.scenario.id,
                label: `${
                    x.scenario.name ?? "Scenario " + x.scenario.functionalName
                } (${x.scenario.functionalName})`,
                scenario: x.scenario,
                title: (x.isCurrent || x.isIdentical)
                        ? $_("impact.map.compare.toolbox.nochanges")
                        : ""
            };
        });

        //console.log(scenarios);

        // find a scenario that is different.
        if (scenarios.length > 0) {
            const i = scenarios.findIndex(
                (x) => !x.isCurrent && !x.isIdentical
            );
            if (i < 0) return;

            scenarioId = scenarios[i].scenario.id;
        }
    };

    otherScenarios.subscribe(() => {
        onOtherScenarioUpdated();
    });

    onMount(() => {
        onOtherScenarioUpdated();
    });
</script>

<ToolBoxModal
    isOpen={$openToolBox === "compare"}
    title={$_("impact.map.compare.toolbox.title")}>
    <label class="mb-8 mt-2">
        <input bind:checked={isChecked} type="checkbox" />
        {$_("impact.map.compare.toolbox.check")}
    </label>
    <FormGroup>
        {#each scenarios as s, i}
            <Input
                id={`scenario-${i}`}
                type="radio"
                bind:group={scenarioId}
                value={s.value}
                label={s.label}
                disabled={s.isCurrent || s.isIdentical} 
                title={s.title}/>
        {/each}
    </FormGroup>
</ToolBoxModal>
